export const LocaleMapping: { [key: string]: string } = {
    ua: 'uk'
};
